<template>
  <div v-if="timeout > 0">
    <VueCountdown
      :time="timeout"
      class="d-block"
      style="font-size: 0.95em;"
      :transform="transformSlotProps"
      v-slot="{ days, hours, minutes, seconds }"
    >
      <strong class="d-flex align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256"><path fill="currentColor" d="M232 136.66A104.12 104.12 0 1 1 119.34 24a8 8 0 0 1 1.32 16A88.12 88.12 0 1 0 216 135.34a8 8 0 0 1 16 1.32ZM120 72v56a8 8 0 0 0 8 8h56a8 8 0 0 0 0-16h-48V72a8 8 0 0 0-16 0Zm40-24a12 12 0 1 0-12-12a12 12 0 0 0 12 12Zm36 24a12 12 0 1 0-12-12a12 12 0 0 0 12 12Zm24 36a12 12 0 1 0-12-12a12 12 0 0 0 12 12Z"/></svg>
        <span class="ml-2">{{ $t('Remaining time') }}: {{ minutes }}:{{ seconds }}</span>
      </strong> <small class="text-muted">
        {{ $t('Beyond this time, the reservation we retain will be available again for others') }}
      </small>
    </VueCountdown>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import { computed } from "vue";
import VueCountdown from '@chenfengyuan/vue-countdown';

const props = defineProps({
  booking: {
    type: Object,
    required: true
  },
});

const timeout = computed(() => props.booking?.expire_at ? dayjs(props.booking.expire_at).diff(dayjs(), 'second') * 1000 : 0);

const transformSlotProps = (props) => {
  const formattedProps = {};
  Object.entries(props).forEach(([key, value]) => {
    formattedProps[key] = value < 10 ? `0${value}` : String(value);
  });
  return formattedProps;
}

</script>

<style scoped>

</style>